import { apiRequest } from '../../shared/api';

export interface IntegrationErrorItem {
  id: string;
  messageId?: string | null;
  errorCode: string;
  errorType: string;
  errorMessage?: string | null;
  retryable: boolean;
  stackReference?: string | null;
  metadata?: any;
  createdAt: string;
  message?: {
    id: string;
    messageType: string;
    status: string;
    sourceSystem?: string | null;
    targetSystem?: string | null;
  };
}

export interface RecordErrorInput {
  messageId?: string;
  attemptId?: string;
  errorCode: string;
  errorType: string;
  errorMessage?: string;
  retryable?: boolean;
  stackReference?: string;
  metadata?: any;
}

export const integrationErrorService = {
  async getErrors(params?: { type?: string; retryable?: boolean; limit?: number }): Promise<IntegrationErrorItem[]> {
    const q = new URLSearchParams();
    if (params?.type) q.append('type', params.type);
    if (params?.retryable !== undefined) q.append('retryable', String(params.retryable));
    if (params?.limit) q.append('limit', String(params.limit));

    const qs = q.toString() ? `?${q.toString()}` : '';
    return await apiRequest<IntegrationErrorItem[]>(`/v1/integrations/errors${qs}`);
  },

  async getRetryableErrors(): Promise<IntegrationErrorItem[]> {
    return await apiRequest<IntegrationErrorItem[]>('/v1/integrations/errors/retryable');
  },

  async getErrorsByMessageId(messageId: string): Promise<IntegrationErrorItem[]> {
    return await apiRequest<IntegrationErrorItem[]>(`/v1/integrations/messages/${messageId}/errors`);
  },

  async recordError(payload: RecordErrorInput): Promise<IntegrationErrorItem> {
    return await apiRequest<IntegrationErrorItem>('/v1/integrations/errors', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }
};
